export default "__VITE_ASSET__eC_eijrq__"